// eslint-disable-next-line no-use-before-define
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { ToastContainer } from './style';
import { withParams } from '../../libs/i18n/translate';
/** Tempo que a notificação fica na tela antes de sumir sozinha. */
const AUTO_DISMISS_MS = 8000;
const ToastItem = ({ notification, onDismiss }) => {
    const { t } = useTranslation('drawerAssistance');
    const { id, type, messageKey, params } = notification;
    useEffect(() => {
        const timeoutId = window.setTimeout(() => onDismiss(id), AUTO_DISMISS_MS);
        return () => window.clearTimeout(timeoutId);
    }, [id]);
    return (React.createElement("div", { className: `root-app_toast ${type}`, role: "status" },
        React.createElement("p", null, withParams(t)(`drawerAssistance:${messageKey}`, params)),
        React.createElement("button", { type: "button", "aria-label": t('drawerAssistance:toastDismiss'), onClick: () => onDismiss(id) }, "\u2715")));
};
export const ToastComponent = ({ notifications, dismissNotification, }) => {
    const items = notifications ?? [];
    if (items.length === 0 || !dismissNotification) {
        return null;
    }
    return (React.createElement(ToastContainer, null, items.map((notification) => (React.createElement(ToastItem, { key: notification.id, notification: notification, onDismiss: dismissNotification })))));
};
//# sourceMappingURL=component.js.map